import type { SVGProps } from "react";
import omit from "@/utils/omit";

const IconRankFirstBg = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="108"
      height="128"
      viewBox="0 0 108 128"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      {...omit(props, ["className"])}
      className="yfm-icon-rank-first-bg"
    >
      <path
        d="M0 16C0 7.16346 7.16344 0 16 0H92C100.837 0 108 7.16344 108 16V97.8499C108 104.542 103.836 110.526 97.5612 112.852L59.5612 126.939C55.973 128.269 52.027 128.269 48.4388 126.939L10.4388 112.852C4.1643 110.526 0 104.542 0 97.8499V16Z"
        fill="#22F5EE"
      />
    </svg>
  );
};

IconRankFirstBg.displayName = "IconRankFirstBg";

export default IconRankFirstBg;
